import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/styles/index.css';
import "./assets/styles/sidebar.css";
import RoutesIndex from './routes/RoutesIndex';
import { DataProvider } from './services/DataContext';
import {CustomThemeProvider} from "./services/ThemeProvider/ThemeProvider";

const Index = () => {
  return (
    <React.StrictMode>
      <DataProvider>
        <CustomThemeProvider institution='aebel'>
          <RoutesIndex />
        </CustomThemeProvider>
      </DataProvider>
    </React.StrictMode>
  );
}

ReactDOM.createRoot(document.getElementById('root')).render(<Index />);
